const { __, _x, _n, _nx } = wp.i18n;

function LoadingSpinner(props) {
	return (
		<div className="loading-spinner spinner-border text-primary" role="status">
			<span className="sr-only">' + __( 'Loading...', 'iportal-core' ) + '</span>
		</div>
	);
}

export default LoadingSpinner;